module.exports = {
  pleaseWait: 'Please wait',
  loading: 'loading',
  Billing: 'Billing',
  billingTips: 'Your Purchased History',
  ID: 'ID',
  FAQ: 'FAQ',
  TC: 'T&C',
  Copyright: '© 2024 All Rights Reserved.',
  GenerateImage: 'Generate Image',
  generateTips1: 'Our AI image generator brings imagination to life, producing stunning art, illustrations, and photos in seconds. Unleash creativity and express yourself in new ways with the power of AI. Explore endless possibilities, from crafting unique marketing materials to creating beautiful artwork, all with supreme ease and efficiency.',
  generateTips2: 'Enter a few words below, and watch Snapai transform text into incredible art.',
  Prompt: 'Prompt',
  PromptTips1: 'Tell AI what to draw.',
  PromptTips2: 'Tips: describe mood and lighting. See page tips for more.',
  PromptTips3: 'Note: AI may not follow instructions and cannot count.',
  Generate: 'Generate',
  ChancesLeft: 'Chances Left',
  BuyChances: 'Buy More Chances',
  generateImageTips1: 'Input what you want',
  generatePromptsTips1: 'Input what you don\'t want',
  indexTips1: 'Daily Free Chance <br /> Available!',
  indexTips2: 'Choose one of these',
  ImageRestorer: 'Image Restorer',
  Continue: 'Continue',
  language0: 'Language',
  language: 'Choose Language',
  languageTips: 'Choose your language here',
  Submit: 'Submit',
  change: 'Change',
  English: 'English',
  Myanmar: 'Myanmar',
  Login: 'Login',
  Logout: 'Log out',
  getCode: 'Resend',
  loginTips: 'Enter a phone number',
  profile: 'Profile',
  phoneNumber: 'Phone Number',
  SubscribedSince: 'Subscribed since',
  RemainingChances: 'Remaining chances',
  cgtips2: 'Only 149ks/daily,<br />please click OK to subscribe.',
  cgtips2W: 'Only 599ks/weekly,<br />please click OK to subscribe.',
  cgtips2M: 'Only 1999ks/monthly,<br />please click OK to subscribe.',
  OK: 'OK',
  PictureRestorer: 'Picture Restorer',
  PictureTips1: 'Restore, sharpen, and repair pictures with AI. Snapai builds on the latest research to automatically remove scratches, sharpen colors, and enhance faces, transforming damaged photos into cherished memories. Our free service repairs both color photos and black & white ones.',
  Upload: 'Upload',
  PictureTips2: 'Has Scratch?',
  Restore: 'Restore',
  uploadTips: 'Please upload pictures',
  PurchaseChances: 'Purchase Chances',
  History: 'History',
  purchaseTips1: 'Your total chances',
  purchaseTips2: 'One Time Purchase',
  Daily: 'Daily',
  Weekly: 'Weekly',
  OneTime: 'One Time',
  Purchase: 'Purchase',
  DailyKyats: '169 Kyats',
  WeeklyKyats: '699 Kyats',
  OneTimeChance: '149 Ks/Chance',
  Subscribe: 'Subscribe',
  purchaseTips3: 'Please choose how many <strong>CHANCES</strong> to buy.',
  BuyNow: 'Buy Now',
  logout: 'Logout',
  petTitle1: 'AI Pets Anime',
  petTitle2: 'Choose Style',
  petContent1: ' transforms your beloved pet’s photo into a whimsical, anime-style masterpiece. Perfect for pet lovers and anime enthusiasts, Snapai offers a fun and personalized way to celebrate your furry friends.',
  sexTitle1: 'AI Personal Anime',
  sexTitle2: 'Choose Gender',
  sexContent1: 'Brings your imagination to life by generating anime-style photos based on written prompts. Whether you\'re a fan of anime, a storyteller, or a designer, AI Anime Photo empowers you to create vibrant, high-quality anime-style visuals effortlessly, blending advanced AI with your unique vision.',
  sexContent2: 'Choose the gender below and enter the prompt below. Watch Snapai transfor text into incredible art.',
  Female: 'Female',
  Male: 'Male',
  Style1: 'Style 1',
  Style2: 'Style 2',
  Style3: 'Style 3',
  Comic: 'Comic',
  Disney: 'Disney',
  Ghibli: 'Ghibli',
  Animalanime: 'Selfie Anime',
  HumanAnime: 'Human Anime',
  Guidance: 'Guidance',
  PetAnime: 'Pet Anime',
  landTips1: 'Generate Stunning Photos &',
  landTips2: 'WIN BIG PRIZES!',
  landTips3: 'Transform your imagination into reality with SnapAI! From stunning photo generation to artistic masterpieces, SnapAI empowers you to create visuals like never before. Dive into a world of limitless possibilities.',
  show401tip: 'Balance not enough',
  show400dailytip: 'Time out, please send "ON1" to 548 to win the big prize.',
  show400weeklytip: 'Time out, please send "ON7" to 548 to win the big prize.',
  register: 'Register',
  invitation: 'Invitation',
  invitationTips: 'Copy and send invite using the link below',
  InviteNow: 'Invite Now',
  copySuccess: 'Copy Success!',
  CopySucceeded: 'Copy Success!',
  process: 'Generating',
  downTips1: 'Please copy the link into browser and download.',
  copyLink: 'Copy link',
  free: 'Free',
  aiAnimeTitle: 'AI Couples Anime',
  aiAnimeCt1: 'Transform your original couple photos into anime-style images, making your romantic memories even more fun. Whether you\'re an anime enthusiast or a designer, AI Anime Photo allows you to effortlessly create meaningful and high-quality anime-style visuals, perfectly blending advanced AI technology with your romantic moments. ',
  aiAnimeCt2: 'Select the style below and upload your original photo to watch Snapai transform your sweet memories into stunning artworks.',
  comingsoonT: 'coming soon',
  SubscribePackage: 'Subscribe Package',
  landfont1: 'Turn photo into stunning anime artwork.',
  landfont2: 'Transform your couple photos into beautiful anime characters.',
  landfont3: 'Write a prompt to generate beautiful images',
  landfont4: 'Turn your pets into adorable anime characters with AI magic!',
  landfont5: 'Rediscover your memories with AI-powered photo restoration.',
  SmartCutout: 'Smart Cutout',
  letgo: 'Let’s Go',
  IpIMage: 'ID Photo',
  IpIMageTip: 'Need a license or ID photo created? We’ve got you covered!',
  IpIMage_content: 'The original image uploaded for the ID photo must ensure that the face of the person is clear, without any obstruction, and the shoulders are level and even. Otherwise, the generation may fail. ',
  snapbot: 'SnapBot',
  snapbot_hi: 'Hi, I’m SnapBot.',
  help_today: 'How can I help you today?',
  think_ip: '🤖 Thinking...',
  Coloring_old_photos: 'Image Recolor',
  Coloring_old_photos_tips: 'Bring your memories back to life by restoring color\n' +
    'to your vintage photos. Our AI-powered tool\n' +
    'automatically analyzes and adds natural color tones,\n' +
    'preserving the charm of the original while\n' +
    'enhancing its visual appeal.\n',
  Coloring_old_photos_tips2: ' Bring your old photos to life with AI-powered color restoration.',
  BgFusion: 'Smart Blend',
  BgFusion_tips2: 'Customize your photo with a background of your choice',
  BgFusion_tips: 'Customize your photo with a background of your choice.\n' +
    'Our smart AI replaces the original backdrop\n' +
    'and blends your image naturally into the new scene ',
  Upload_bg: 'Upload Background',
  Upload_pt: 'Upload Portrait',
  Recolor: 'Recolor',
  snapbotTips1: 'Fast Search Results',
  snapbotTips2: 'Natural Language processing',
  snapbotTips3: 'Big Data Analysis',
  snapbotTips4: 'AI-powered Algorithms',
  snapbotInput1: 'Tap here to start with SnapBot',
  white: 'white',
  blue: 'blue',
  '1 inch': '1 inch',
  '2 inches': '2 inch',
  '3 inches': '3 inch',
  landTips11: 'Create Awesome Photos &',
  ChangeHairstyle: 'Hairstyle Magic',
  ChangeHairstyle_short: 'Create and try out your Imagined Hairstyles',
  ChangeHairstyle_content_1: 'The snapai app offers a feature for changing hairstyles, allowing users to try on different haircuts in real-time or via uploaded photos. This feature leverages AI technology to analyze the user’s facial features and suggest hairstyles that suit their face shape, preferences, and style. Users can experiment with various looks, ranging from subtle changes to bold, dramatic transformations, giving them a virtual preview before committing to an actual change. The app provides an easy and fun way for users to explore different hairstyles and find the perfect one for them.',
  ChangeHairstyle_content_2: 'Choose your favorite hairstyle below and add your own photo. You will get a beautiful and clear image.',
  Result: 'Result',
  Original: 'Original',
  unsub_tip: 'To unsubscribe, send OFF to 548',
  sub_tip: 'For subscription,send "ON1" or "ON7" to 548',
  longHairEffects: 'Long Hair Effect',
  longHairEffects_tip: 'Try the Long Hair Effect it gives you a natural and attractive hairstyle. This effect creates the look of longer hair for you.\n' +
    'Smooth & shiny\n' +
    'Natural-looking length\n' +
    'Perfect for any outfit, Look your best every day with the Long Hair Effect!',
  VIDEO: 'VIDEO',
  image_video: 'Image To Video',
  image_video_tip: 'This function turns a still photo into a lively 1–3 minute animated video, adding natural facial expressions and movements to make the image come alive. Users can also check previously generated videos from their history.',
  word_video: 'Word To Video',
  word_video_tip: 'This function transforms the text you have written into a dynamic, lifelike video using AI technology, allowing it to reflect your preferred style and expression. It may take 1–3 minutes to generate the video, and previously created videos can be reviewed in the history record.',
  word_video_input: "Describe the style and appearance of the video you want to create.",
  image_video_input: "Describe the style and appearance of the photo you want to create.",
  aiDressUp: "AI DressUp",
  aiDressUp_tip: "With AI Dress Up, change your look instantly!\n" +
    "Upload your photo and try endless outfits—\n" +
    "traditional, formal, or trendy. The SnapAI fits clothes\n" +
    "naturally to your body, letting you preview\n" +
    "new styles and have fun exploring fashion.",
  singleheart: "Love You Effect",
  singleheart_desc: "Share your affection! Add a sweet and romantic heart-shaped effect to your video and show someone you care.",
  aiVividScene: "Vivid AI Scene",
  aiVividScene_desc: "Capture the perfect photo for every mood and season with the new AI Scene Creator! If you have just one clear photo of your face, you can easily select various Backgrounds, Styles, and Color Tones to generate stunning, richly colored photos in countless scenarios. Instantly place yourself in a summer beach scene, a nighttime cityscape, a rainy day street, or any fantasy setting, all without needing to be there in person.",
  pic_size_limit: "Images cannot exceed 5MB",
  spin_tip_1: "Don't miss your chance!",
  spin_tip_2: "The spin wheel only provide in daily quest campaign",
  close: "close",
  spin: 'Spin',
  SpinChances: 'Spin Chances',
  date: 'Date',
  Prizes: 'Prizes',
  nochance: 'You don\'t have enough chance',
  WinnerList: 'Winner List',
  Congratulations: "Congratulations !you won",
  Confirm: "Confirm",
  spinTips2: 'Daily Free Spin!',
  spinTips3: 'Claim your FREE Lucky Spin Token and try your luck today!',
  spinTips4: 'Get My Token',
  No: 'No',
  not_win: "Thank you for playing. Better Luck next time!",
  win_tip: 'Tap below to collect your reward',
  Trending: 'Trending',
  Face_Magic: 'Face Magic',
  AI_Studio: 'AI Studio',
  Home: 'Home',
  unsubscribe: 'UnSubscribe',
  Back: 'Back',
  Chances: 'Chances',
  Setting: 'Setting',
  Menu: 'Menu',
  New: 'New',
  image_max_size: "File size exceeds 5MB",
  file_max_size: "File size exceeds 1MB",
  new_chat: "New Chat",
  file: "File",
  image: "Image",
  invalid_image_format: "invalid file format",
  Shoot_same_video: "Shoot video",
  categories: "Categories",
  beauty_category: "Beauty",
  ai_doc: "AI Doc",
  ai_ppt_title: "AI Power Points",
  ai_ppt_tip: "One prompt with fast & high impact presentation that satisfies every audience.",
  ai_ppt_tips: "Turn ideas into stunning visuals in seconds.Create high-quality images, artwork, and designs effortlessly with AI.From social media content to unique creative projects — bring your imagination to life with just a few words.",
  ai_resume_title: "AI Resume Form",
  ai_resume_tip: "Generate a professional AI resume in seconds and land your dream job.",
  author_tip: "Please enter the author's name",
  Template: 'Template',
  TemplateColor: 'Template Color',
  Background: 'Background',
  UploadAvatar: 'Upload Avatar',
  ResumePhoto: 'Resume Photo',
  BasicInfo: 'Basic Info',
  'Full Name': 'Full Name',
  'Job Role': 'Job Role',
  Email: 'Email',
  'Phone Number': 'Phone Number',
  Address: 'Address',
  Summary: 'Summary',
  Education: 'Education',
  Institution: 'Institution',
  Degree: 'Degree',
  'Start Date (YYYY-MM-DD)': 'Start Date (YYYY-MM-DD)',
  'End Date (YYYY-MM-DD)': 'End Date (YYYY-MM-DD)',
  'Currently Studying Here': 'Currently Studying Here',
  'Short Description': 'Short Description',
  Achievements: 'Achievements',
  'Achievement text': 'Achievement text',
  Employment: 'Employment',
  'Job Title': 'Job Title',
  Company: 'Company',
  'Currently Working Here': 'Currently Working Here',
  Responsibilities: 'Responsibilities',
  'Responsibility text': 'Responsibility text',
  Skills: 'Skills',
  'Skill Name': 'Skill Name',
  Add: 'Add',
  'Add Education': 'Add Education',
  'Add Employment': 'Add Employment',
  'Add Skill': 'Add Skill',
  'ai_image': 'AI Image',
  ai_makeup_title: 'AI Makeup Try-On',
  ai_makeup_tip: 'Upload a clear selfie and choose a makeup look. SnapAI will generate a realistic virtual makeup preview for you.',
  makeup_select_look: 'Select Makeup Look',
  makeup_upload_hint: 'Upload a clear front-facing selfie for best results',
  makeup_category_blush: 'Blush',
  makeup_category_contour: 'Contour',
  makeup_category_bronzer: 'Bronzer',
  makeup_preset_natural: 'Natural Glow',
  makeup_preset_natural_desc: 'Soft pink blush with a clean everyday finish.',
  makeup_preset_sunset: 'Sunset Blush',
  makeup_preset_sunset_desc: 'Warm two-tone blush for a brighter cheerful look.',
  makeup_preset_contour: 'Soft Contour',
  makeup_preset_contour_desc: 'Gentle contour and bronzer for more face definition.',
  makeup_preset_bold: 'Bold Cheeks',
  makeup_preset_bold_desc: 'Richer blush tones with a more vivid makeup style.',
  makeup_select_look_tip: 'Tap a makeup preview image to choose the style you want.',
  makeup_category_eyebrows: 'Eyebrows',
  makeup_category_eyelashes: 'Eyelashes',
  makeup_category_eyeliner: 'Eyeliner',
  makeup_category_eyeshadow: 'Eyeshadow',
  makeup_category_highlighter: 'Highlighter',
  makeup_category_lipliner: 'Lip Liner',
  makeup_load_more: 'Load More',
  makeup_choose_category: 'Tap a category to open the style picker. Your selections will be kept for each category.',
  makeup_selected_looks: 'Selected Looks',
  makeup_selected_empty: 'No category selected yet. Tap a category above to choose a style.',
  makeup_result_title: 'Generated Result',
  makeup_generating_title: 'AI Makeup Is Generating',
  makeup_generating_desc: 'SnapAI is blending your selected makeup styles and creating a realistic preview.',
  makeup_generating_wait: 'AI rendering',
  makeup_timeout_tip: 'The makeup image is still generating. Please check it later in History.',
  upload_examples: 'Example Photos',
  ai_look_title: 'AI Look Try-On',
  ai_look_tip: 'Upload a clear selfie and choose one professional look template. SnapAI will apply the full style for you.',
  look_select_template: 'Select Look Template',
  look_choose_category: 'Tap a category to open the template picker. The data is cached locally and ready to browse.',
  look_choose_subcategory: 'Choose a subgroup before selecting a template.',
  look_selected_template: 'Selected Template',
  look_selected_empty: 'No look template selected yet. Tap a category above to choose one.',
  look_select_template_tip: 'Tap a template preview image to choose the look you want.',
  look_cat_all: 'All',
  look_cat_animals: 'Animals',
  look_cat_sports: 'Sports',
  look_cat_halloween: 'Halloween',
  look_cat_summer: 'Summer',
  look_cat_cinema: 'Cinema',
  look_cat_on_stage: 'On Stage',
  look_cat_chinese_style: 'Chinese Style',
  look_cat_japanese_style: 'Japanese Style',
  look_cat_horoscope: 'Horoscope',
  look_cat_red_carpet: 'Red Carpet',
  look_cat_pride: 'Pride',
  look_cat_fashion_week: 'Fashion Week',
  look_cat_festival: 'Festival',
  look_cat_valentine: 'Valentine',
  look_cat_celebrity: 'Celebrity',
  look_cat_dating: 'Dating',
  look_cat_work: 'Work',
  look_cat_spring: 'Spring',
  look_cat_wedding: 'Wedding',
  look_cat_makeup_artist: 'Makeup Artist',
  look_cat_ever_after_beauty_collection: 'Ever After Beauty Collection',
  look_cat_k_pop: 'K-Pop',
  look_cat_daily: 'Daily',
  look_cat_party: 'Party',
  look_cat_holidays: 'Holidays',
  look_generating_title: 'AI Look Is Generating',
  look_generating_desc: 'SnapAI is applying your selected professional look and creating a realistic preview.',
  look_generating_wait: 'AI rendering',
  look_timeout_tip: 'The AI look image is still generating. Please check it later in History.',
  ai_hair_color_title: 'AI Hair Color',
  ai_hair_color_tip: 'Upload a clear selfie and choose one hair color preset. SnapAI will recolor your hair and generate a realistic preview for you.',
  hair_color_select_preset: 'Select Hair Color Template',
  hair_color_choose_category: 'Tap a template image below to choose one hair color preset.',
  hair_color_selected: 'Selected Template',
  hair_color_selected_empty: 'No hair color template selected yet.',
  hair_color_select_tip: 'Tap a template card to choose the preset you want.',
  hair_color_generating_title: 'AI Hair Color Is Generating',
  hair_color_generating_desc: 'SnapAI is recoloring your hair with the selected preset and creating a realistic preview.',
  hair_color_generating_wait: 'AI rendering',
  hair_color_timeout_tip: 'The AI hair color image is still generating. Please check it later in History.',
  ai_clothes_title: 'AI Clothes Try-On',
  ai_clothes_tip: 'Upload a clear full-body photo and a clothing reference image, then choose the garment category. SnapAI will create a virtual try-on preview for you.',
  clothes_user_photo_title: 'Upload Your Photo',
  clothes_user_photo_hint: 'Upload a clear full-body standing photo with one person only.',
  clothes_reference_title: 'Upload Clothing Reference',
  clothes_reference_hint: 'Upload a clothing product photo or a full-body outfit reference image.',
  clothes_category_title: 'Select Garment Category',
  clothes_category_tip: 'Choose the category that best matches the clothing reference image before generating.',
  clothes_category_auto: 'Auto Detection',
  clothes_category_upper: 'Upper Body',
  clothes_category_lower: 'Lower Body',
  clothes_category_full: 'Full Body',
  clothes_category_shoes: 'Shoes',
  clothes_reference_tab_upload: 'Upload',
  clothes_reference_tab_sample: 'Sample',
  clothes_reference_upload_hint: 'Upload your own clothing reference image to try on.',
  clothes_sample_see_all: 'See all',
  clothes_selected_reference: 'Selected Reference',
  clothes_selected_reference_empty: 'No clothing template selected yet.',
  clothes_sample_modal_title: 'Select Clothing Template',
  clothes_selected_category: 'Selected Category',
  clothes_selected_empty: 'No garment category selected yet.',
  clothes_generating_title: 'AI Clothes Is Generating',
  clothes_generating_desc: 'SnapAI is fitting the clothing reference onto your photo and creating a realistic try-on preview.',
  clothes_generating_wait: 'AI rendering',
  clothes_timeout_tip: 'The AI clothes image is still generating. Please check it later in History.',
  ai_bag_title: 'AI Bag Try-On',
  ai_bag_tip: 'Upload a clear selfie and a bag reference image, then choose your gender. SnapAI will create a virtual bag try-on preview for you.',
  bag_user_photo_title: 'Upload Your Photo',
  bag_user_photo_hint: 'Upload a clear selfie with upper body visible, one person only.',
  bag_reference_title: 'Upload Bag Reference',
  bag_reference_hint: 'Upload a bag product photo or a person carrying a bag without obstruction.',
  bag_gender_title: 'Select Gender',
  bag_gender_tip: 'Choose the gender you wish to visualize with the bag.',
  bag_reference_tab_upload: 'Upload',
  bag_reference_tab_sample: 'Sample',
  bag_reference_upload_hint: 'Upload your own bag reference image to try on.',
  bag_sample_see_all: 'See all',
  bag_selected_reference: 'Selected Reference',
  bag_selected_reference_empty: 'No bag template selected yet.',
  bag_sample_modal_title: 'Select Bag Template',
  bag_generating_title: 'AI Bag Is Generating',
  bag_generating_desc: 'SnapAI is placing the bag onto your photo and creating a realistic try-on preview.',
  bag_generating_wait: 'AI rendering',
  bag_timeout_tip: 'The AI bag image is still generating. Please check it later in History.',
  sharePanelTitle:'Share with friends',
  sharePanelTips:'Choose a platform below and send your invite link directly.',
  shareMore:'More Options',
  Copy:'Copy',
  referralTips1:"I found something interesting and wanted to share it with you. Come and join me",

};



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js